import { apiSlice } from "@/redux/rtk/features/apiSlice/apiSlice";
import { toastHandler } from "@/utils/functions";
import queryGenerator from "@/utils/queryGenarator";

export const campaignCodeApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCampaignCode: builder.query({
      query: ({ id }) => ({
        url: `campaign-code/${id}`,
      }),
      providesTags: ["CampaignCode"],
    }),
    getCampaignCodes: builder.query({
      query: () => ({
        url: `campaign-code?query=all`,
      }),
      providesTags: ["CampaignCodeAll"],
    }),
    getCampaignCodesPaginated: builder.query({
      query: (arg) => {
        const query = queryGenerator(arg);
        return {
          url: `campaign-code?${query}`,
        };
      },
      providesTags: ["CampaignCodes"],
    }),

    addCampaignCode: builder.mutation({
      query: (values) => ({
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        url: `campaign-code`,
        body: values,
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toastHandler("Campaign Code added successfully", "success");
        } catch (err) {
          toastHandler("Something went wrong, Please try again", "warning");
        }
      },
      invalidatesTags: ["CampaignCodes", "CampaignCodeAll"],
    }),

    deleteCampaignCode: builder.mutation({
      query: ({ id }) => ({
        url: `campaign-code/${id}`,
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toastHandler("Deleted Campaign Code successfully", "warning");
        } catch (err) {
          toastHandler("Something went wrong, Please try again", "warning");
        }
      },
      invalidatesTags: ["CampaignCode", "CampaignCodes", "CampaignCodeAll"],
    }),

    updateCampaignCode: builder.mutation({
      query: ({ id, values }) => ({
        url: `campaign-code/${id}`,
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        },
        body: values,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          await queryFulfilled;
          toastHandler("Campaign Code updated successfully", "success");
        } catch (err) {
          toastHandler("Something went wrong, Please try again", "warning");
        }
      },
      invalidatesTags: ["CampaignCode", "CampaignCodes", "CampaignCodeAll"],
    }),
  }),
});

export const {
  useGetCampaignCodeQuery,
  useGetCampaignCodesQuery,
  useAddCampaignCodeMutation,
  useDeleteCampaignCodeMutation,
  useUpdateCampaignCodeMutation,
  useGetCampaignCodesPaginatedQuery,
} = campaignCodeApi;
